import { Suspense } from 'react';

import type { AmplitudeClientHandler } from '@repo/amplitude/client';
import { SessionReplayHandler } from '@repo/amplitude/session-replay';

import { useSessionReplay } from 'contexts/analytics/useSessionReplay';
import useIsSessionReplayEnabled from 'services/features/useIsSessionReplayEnabled';

type SessionReplayProps = {
  amplitude: AmplitudeClientHandler | null;
};

const SessionReplayGate = ({ amplitude }: SessionReplayProps) => {
  const { isEnabled } = useIsSessionReplayEnabled();
  useSessionReplay(amplitude ? SessionReplayHandler.instance : null, isEnabled);
  return null;
};

export const SessionReplay = (props: SessionReplayProps) => (
  <Suspense fallback={null}>
    <SessionReplayGate {...props} />
  </Suspense>
);
